export default function About(){
    debugger
    return(
        <>
       <b> <p>hi,
        Our store is one of a kind<br></br>
The shopping experience is convenient for users, the prices are really reasonable, and the service is above and beyond
<br></br>
Our products are manufactured to a fairly high quality so that the strollers remain strong and good for use even after years.
<br></br> 
The strollers are safe and come under constant supervision.
<br></br>
We have the most modern and strongest models on the market and the goods are updated every six months.
<br></br>
Our delivery is immediate and if you ordered delivery - within three to five days the order will arrive at the given address.
<br></br>
 Our couriers are reliable and classified and give the best possible service.
 <br></br>
The store is open two days a week, but the site is always for your use
Waiting for you and always at your service
        </p></b>
        </>
    )

}